/**
 * MT 全屏展示：随滚动从 0 缓慢旋转到配置角度
 */
(function () {
  'use strict';

  function parseDeg(value) {
    if (value == null || value === '') return 0;
    var match = String(value).match(/(-?[\d.]+)\s*deg/);
    return match ? parseFloat(match[1]) : 0;
  }

  function parseNumber(value, fallback) {
    if (value == null || value === '') return fallback;
    var n = parseFloat(String(value));
    return Number.isFinite(n) ? n : fallback;
  }

  function updateBlockRotate(block, section) {
    var rect = block.getBoundingClientRect();
    var vh = window.innerHeight;

    // 通过“更长的滚动区间”让变化更慢、更柔和（单位：vh）
    // startVh: rect.top 到达该位置开始变化；endVh: rect.top 到达该位置结束变化
    // 默认：0.9vh -> -0.1vh（比原来的 0.75->0.25 区间长很多）
    var sectionStyle = section ? window.getComputedStyle(section) : null;
    var startVh = parseNumber(sectionStyle && sectionStyle.getPropertyValue('--mt-fs-scroll-start-vh'), 0.9);
    var endVh = parseNumber(sectionStyle && sectionStyle.getPropertyValue('--mt-fs-scroll-end-vh'), -0.1);

    var start = startVh * vh;
    var end = endVh * vh;

    var progress = 1 - (rect.top - end) / (start - end);
    progress = Math.min(1, Math.max(0, progress));

    var style = block.currentStyle || window.getComputedStyle(block);
    var leftTarget = parseDeg(style.getPropertyValue('--block-left-rotate'));
    var rightTarget = parseDeg(style.getPropertyValue('--block-right-rotate'));

    block.style.setProperty('--block-left-rotate-scroll', progress * leftTarget + 'deg');
    block.style.setProperty('--block-right-rotate-scroll', progress * rightTarget + 'deg');
  }

  function init() {
    var section = document.querySelector('.mt-fullscreen-showcase');
    if (!section) return;

    var blocks = section.querySelectorAll('.mt-fullscreen-showcase__block');
    if (!blocks.length) return;

    function onScroll() {
      blocks.forEach(function (block) {
        updateBlockRotate(block, section);
      });
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
